import styled, { css, keyframes } from 'styled-components';
import { themeVariant, px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';
import { spacing } from '../constants/spacing.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { boxStyles } from '../Box/styles.js';
import { TinyColor } from '@ctrl/tinycolor';

var getActive = function getActive(_ref) {
  var readOnly = _ref.readOnly,
      disabledStyle = _ref.disabledStyle,
      color = _ref.color,
      theme = _ref.theme;
  return readOnly || disabledStyle ? theme.radio.web.disabled.borderColor : color;
};

var getInactiveBorderColor = function getInactiveBorderColor(_ref2) {
  var readOnly = _ref2.readOnly,
      inactiveColor = _ref2.inactiveColor,
      theme = _ref2.theme;
  return readOnly ? theme.radio.web.disabled.borderColor : inactiveColor;
};

var field = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__field",
  componentId: "sc-9079lb-0"
})(["", " display:inline-block;position:relative;", ""], fontFamilyStyles, boxStyles);
var textLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "styles__textLabel",
  componentId: "sc-9079lb-1"
})(["color:", ";cursor:pointer;display:block;font-size:", ";line-height:", ";min-height:", ";padding-left:", ";position:relative;user-select:none;&:empty{padding-left:", ";}&:before{background:", ";border-radius:100%;box-sizing:border-box;border:", " solid ", ";content:'';height:", ";left:0;position:absolute;top:0;transition:border ", ";transition-timing-function:", ";width:", ";}"], function (p) {
  return p.theme.radio.web.label.normal;
}, themeVariant({
  normal: function normal(p) {
    return p.theme.radio.web.label.fontSize;
  },
  condensed: function condensed(p) {
    var _p$theme$radio$web$va;

    return (_p$theme$radio$web$va = p.theme.radio.web.variants.condensed.label) === null || _p$theme$radio$web$va === void 0 ? void 0 : _p$theme$radio$web$va.fontSize;
  }
}), themeVariant({
  normal: function normal(p) {
    return p.theme.radio.web.label.lineHeight;
  },
  condensed: function condensed(p) {
    var _p$theme$radio$web$va2;

    return (_p$theme$radio$web$va2 = p.theme.radio.web.variants.condensed.label) === null || _p$theme$radio$web$va2 === void 0 ? void 0 : _p$theme$radio$web$va2.lineHeight;
  }
}), px2rem(24), spacing.m, spacing.xs, function (p) {
  return p.theme.radio.web.background;
}, px2rem(2), getInactiveBorderColor, px2rem(24), styles.transition.timing.faster, styles.transition["function"].base, px2rem(24));
var icon = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__icon",
  componentId: "sc-9079lb-2"
})(["background:", ";border-radius:100%;height:", ";left:0;pointer-events:none;position:absolute;top:0;transition:transform ", ";transition-timing-function:", ";transform:scale(0);width:", ";"], getActive, px2rem(24), styles.transition.timing.faster, styles.transition["function"].base, px2rem(24));
var input = /*#__PURE__*/styled.input.withConfig({
  displayName: "styles__input",
  componentId: "sc-9079lb-3"
})(["opacity:0;position:absolute;~ ", "{&:before{border-color:", ";}}&:checked{~ ", "{&:before{border-color:", ";}}~ ", "{transform:scale(0.5);}}&:focus,&:hover{~ ", "{&:before{border-color:", ";}}}", " ", ""], textLabel, getInactiveBorderColor, textLabel, getActive, icon, textLabel, getActive, function (props) {
  return props.disabledStyle && css(["~ ", "{color:", ";cursor:not-allowed;&:before{background:", ";border-color:", ";}}~ ", "{background:", ";}"], textLabel, props.theme.radio.web.disabled.borderColor, props.theme.radio.web.disabled.backgroundColor, props.theme.radio.web.disabled.borderColor, icon, props.theme.radio.web.disabled.borderColor);
}, function (props) {
  return props.readOnly && css(["~ ", "{background:", ";}~ ", "{&:before{background:", ";}}"], icon, props.theme.radio.web.disabled.borderColor, textLabel, props.theme.radio.web.disabled.backgroundColor);
}); // similar one is in Checkbox styles

var focusAnimation = /*#__PURE__*/keyframes(["from{transform:scale(.1,.1);opacity:0;}to{transform:scale(1,1);opacity:1;}"]);
var focusIndicator = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__focusIndicator",
  componentId: "sc-9079lb-4"
})(["background:", ";display:inline-block;position:absolute;top:", ";left:", ";height:", ";width:", ";border-radius:50%;pointer-events:none;animation:", " ", " forwards;"], function (props) {
  return new TinyColor(props.color).setAlpha(0.1).toRgbString();
}, px2rem(-10), px2rem(-10), px2rem(44), px2rem(44), focusAnimation, styles.transition.timing.base);

export { field, focusIndicator, icon, input, textLabel };
